// extracted by mini-css-extract-plugin
export var arrows = "_56-6";
export var decrementer = "_56-a";
export var disabled = "_56-4";
export var error = "_56-1";
export var hiddenText = "_56-b";
export var incrementer = "_56-9";
export var input = "_56-8";
export var inputWrapper = "_56-0";
export var leadingIcon = "_56-c";
export var readonly = "_56-3";
export var regular = "_56-7";
export var small = "_56-5";
export var warning = "_56-2";